import React from 'react';
import cx from 'classnames';
import { Button, Paper } from 'library';

import './RelatedPostsWrapper.scss';

const RelatedPostsWrapper = ({ theme, buttonLabel, buttonLink, allowShareStory, children }) => {
  const buttonTheme = theme === 'dark' ? 'inverse' : null;

  return (
    <Paper theme={theme} pad={1}>
      <div className={cx('RelatedPostsWrapper', { showShareStory: allowShareStory })}>
        {children}
        {(buttonLink != null || buttonLabel != null) && (
          <Button theme={buttonTheme} href={buttonLink} className="cta-segment-track">
            {buttonLabel}
          </Button>
        )}
        {allowShareStory && (
          <p>
            Have a great experience with Hometap?
            <br />
            <a
              title="Share your story"
              href="https://docs.google.com/forms/d/e/1FAIpQLSesgGynqwOH1Z6XwKxCJ0f4zVSqpxZ0epL_dBg2k4xSE79OEQ/viewform"
              target="_blank"
              rel="noopener noreferrer"
            >
              Share your homeowner story.
            </a>
          </p>
        )}
      </div>
    </Paper>
  );
};

export default RelatedPostsWrapper;
